import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { CheckThickIcon } from '@fiverr-private/icons';
import { grey_400, grey_1200 } from '@fiverr-private/sass/helpers/index';
import { SwitchProps } from './types';
import classes from './index.module.scss';

const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, size = 'md', disabled = false, children, isError = false, ...rest }, ref) => {
    const wrapperClassName = classnames(classes.switcher, [classes[`size-${size}`]], {
      [classes.disabled]: disabled,
      [classes.isError]: isError,
    });
    const toggleClasses = classnames(classes.toggler, {
      [classes.paddingWithChildren]: !!children,
    });
    const inputProps = {
      type: 'checkbox',
      ref,
      disabled,
      role: 'switch',
      className,
      ...rest,
    };

    return (
      <label className={wrapperClassName}>
        <input {...inputProps} />
        <span className={toggleClasses}>
          <span className={classes.swinger}>
            <CheckThickIcon color={disabled ? grey_400 : grey_1200} size={size === 'md' ? 16 : 12} />
          </span>
        </span>
        {children && <span className={classes.internalSelect}>{children}</span>}
      </label>
    );
  }
);

Switch.displayName = 'Switch';

export default Switch;
